import React from 'react';
import { motion } from 'framer-motion';
import { FaFileImage, FaFileAlt, FaFileCode, FaImage, FaFilePdf, FaFile } from 'react-icons/fa';

const formats = [
  {
    name: 'JPG',
    description:
      'JPG (or JPEG) is ideal for photos and web images. It uses lossy compression, balancing quality and size.',
    color: 'bg-yellow-100',
    icon: <FaFileImage className="text-yellow-500 text-4xl" />,
  },
  {
    name: 'PNG',
    description:
      'PNG supports transparency and is lossless, making it great for web graphics like logos.',
    color: 'bg-blue-100',
    icon: <FaFileAlt className="text-blue-500 text-4xl" />,
  },
  {
    name: 'WEBP',
    description:
      'WEBP is a modern format from Google that offers superior compression for both photos and graphics.',
    color: 'bg-green-100',
    icon: <FaImage className="text-green-500 text-4xl" />,
  },
  {
    name: 'GIF',
    description:
      'GIF is perfect for simple animations and supports transparency, but only 256 colors.',
    color: 'bg-purple-100',
    icon: <FaFile className="text-purple-500 text-4xl" />,
  },
  {
    name: 'SVG',
    description:
      'SVG is a vector format, ideal for icons and logos that need to scale without losing quality.',
    color: 'bg-pink-100',
    icon: <FaFileCode className="text-pink-500 text-4xl" />,
  },
  {
    name: 'PDF',
    description:
      'PDF is a versatile format often used for documents, offering high-quality printing and consistent formatting across devices.',
    color: 'bg-red-100',
    icon: <FaFilePdf className="text-red-500 text-4xl" />,
  },
];

function Info() {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-6">
      <h1 className="text-4xl font-bold text-center text-yellow-600 mb-12">Popular File Formats</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {formats.map((format, index) => (
          <motion.div
            key={format.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.6 }}
            viewport={{ once: true }}
            className={`rounded-2xl shadow-xl p-6 ${format.color} hover:scale-105 transform transition-all duration-300`}
          >
            <div className="flex items-center gap-4 mb-4">
              {format.icon}
              <h2 className="text-2xl font-semibold text-gray-800">{format.name}</h2>
            </div>
            <p className="text-gray-700">{format.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Info;
